var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPpt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File icons 24px/PPT",
    clipPath: "url(#clip0_62488_125526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V15H17C15.8954 15 15 15.8954 15 17V21H5C3.89543 21 3 20.1046 3 19V5ZM21 17C21 19.2091 19.2091 21 17 21V17H21ZM9.491 7.948C9.491 6.814 8.623 6.1 7.258 6.1H4.899V11H6.551V9.796H7.258C8.623 9.796 9.491 9.082 9.491 7.948ZM7.825 7.948C7.825 8.305 7.608 8.522 7.153 8.522H6.551V7.374H7.153C7.608 7.374 7.825 7.591 7.825 7.948ZM14.6248 7.948C14.6248 6.814 13.7568 6.1 12.3918 6.1H10.0328V11H11.6848V9.796H12.3918C13.7568 9.796 14.6248 9.082 14.6248 7.948ZM12.9588 7.948C12.9588 8.305 12.7418 8.522 12.2868 8.522H11.6848V7.374H12.2868C12.7418 7.374 12.9588 7.591 12.9588 7.948ZM16.1212 7.381V11H17.7732V7.381H19.2082V6.1H14.6862V7.381H16.1212Z",
    fill: "#3D4400"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_62488_125526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpt);
export default __webpack_public_path__ + "static/media/ppt.874a55ae5d9210fd6b8426f47e8aa42a.svg";
export { ForwardRef as ReactComponent };